import "aos/dist/aos.css";

import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
import { Suspense, lazy } from "react";
import { persistor, store } from "./api/store";

import Aos from "aos";
import Dashboard from "pages/Dashboard";
import EmailVerification from "components/beta-onboarding/emailVerification";
import FAQs from "pages/landing/FAQs";
import Loader from "components/global/Loader";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { authService } from "api";
import Login from "pages/Login";
import AuthRedirect from "pages/AuthRedirect";
import HelpCenter from "views/HelpCenter";
import { QueryClient, QueryClientProvider } from 'react-query'

const queryClient = new QueryClient()

// Pages
const InviteTeamMembers = lazy(() => import("pages/InviteTeamMembers"));
const newBusinessAccount = lazy(() => import("pages/Welcome"));
const PageNotFound = lazy(() => import("pages/PageNotFound"));
const Register = lazy(() => import("pages/Register"));
const VerifyEmail = lazy(() => import("pages/VerifyEmail"));
const VerifyAccountSuccess = lazy(() => import("pages/VerifyAccountSuccess"));
const ForgotPassword = lazy(() => import("pages/ForgotPassword"));
const Legal = lazy(() => import("pages/Legal"));
const Home = lazy(() => import("pages/Home"));
const Pricing = lazy(() => import("pages/Pricing"));

// Axios interceptors
authService();

Aos.init({ duration: 1000 });

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <Suspense fallback={<Loader className="cover" />}>
            <Router>
              <div className="App">
                <HelpCenter />
                <Switch>
                  <Route
                    exact
                    path="/"
                    component={() => <Redirect to="/home" />}
                  />
                  <Route
                    exact
                    path={["/beta", "/beta/home"]}
                    component={() => <Redirect to="/home" />}
                  />
                  <Route exact path="/home" component={Home} />
                  <Route exact path="/sign-in" component={Login} />
                  <Route
                    exact
                    path="/beta/sign-up"
                    component={() => <Redirect to="/sign-up" />}
                  />
                  <Route exact path="/sign-up" component={Register} />
                  <Route
                    exact
                    path="/auth/:provider/callback"
                    component={AuthRedirect}
                  />
                  <Route path="/password-reset" component={ForgotPassword} />
                  <Route exact path="/pricing" component={Pricing} />
                  <Route exact path="/verify-email" component={VerifyEmail} />
                  <Route
                    exact
                    path="/verify-account-success"
                    component={VerifyAccountSuccess}
                  />
                  <Route
                    exact
                    path="/verify-account-success/confirmed"
                    component={() => <EmailVerification verified />}
                  />
                  <Route exact path="/welcome" component={newBusinessAccount} />
                  <Route
                    exact
                    path="/invite-team-members"
                    component={InviteTeamMembers}
                  />
                  <Route path="/dashboard" component={Dashboard} />
                  <Route path="/legal" component={Legal} />
                  <Route path="/faqs" component={FAQs} />

                  {/* No match */}
                  <Route component={PageNotFound} />
                </Switch>
              </div>
            </Router>
          </Suspense>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
